/**
 * Header the browser sets on a risk-event request to name the Fingerprint
 * identification event it ran for that request. The server looks the event up
 * with the Fingerprint secret key rather than trusting anything else the
 * browser says about the device.
 */
export const FINGERPRINT_EVENT_HEADER = "x-fp-event-id";

/**
 * The browser's latest Fingerprint event id, for the risk events recorded on a
 * navigation rather than a fetch: an OAuth callback, a magic-link click or the
 * apply entry render cannot carry the header.
 */
export const FINGERPRINT_EVENT_COOKIE = "terac_fp_event";

/**
 * How old an identification event may be and still name the device. The
 * browser names its event, so an old one may have been lifted from another
 * request. Also the event cookie's lifetime, so the two cannot drift.
 */
export const FINGERPRINT_EVENT_MAX_AGE_SECONDS = 600;

/** The browser's IANA time zone, for risk events recorded on a navigation. */
export const BROWSER_TIMEZONE_COOKIE = "terac_tz";
